import { AppFlow } from '@lib/web-shared';

export interface UtagParam {
  channel: string;
  subchannel1: string;
  subchannel2: string;
  flow?: string;
  page?: string;
  club?: string;
  autopay?: string;
  category?: string[];
  confirmation_id?: string;
  error?: string;
  product?: string[];
  quantity?: string[];
  transaction_amount?: string[];
  transaction_type?: string;
  paymentplan?: string;
  ins_min_due?: string;
  pay_add_amount?: string;
  ins_autopaycampaign?: string;
  state?: string;
  warning?: string;
  ins_policy?: string;
}

export class UtagHelper {
  static loadCommonTags = (appFlow = AppFlow.PAYMENT): UtagParam => {
    return {
      channel: 'my account',
      subchannel1: 'insurance',
      subchannel2: appFlow === AppFlow.AUTOPAY ? 'easy auto pay' : 'easy pay',
      flow: appFlow === AppFlow.AUTOPAY ? 'stand alone auto pay' : 'obp:easy pay',
    };
  };
  static Errors = {
    systemError: 'system error',
    paymentError: 'payment error',
    systemErrorAutoPayFlow: 'error-system',
    autoPayErrorAutoPayFlow: 'error-auto-pay',
    paymentErrorAutoPayFlow: 'error-payment',
    notFoundError: 'page is no longer available',
  };

  static getPages = (appFlow = AppFlow.PAYMENT) => {
    const pageName = appFlow === AppFlow.AUTOPAY ? 'easy auto pay' : 'easy pay';
    return {
      submitInsurancePage: `my account:insurance:${pageName}:enter your policy number`,
      verifyPolicyInfoPage: `my account:insurance:${pageName}:confirm last name`,
      paymentAmountSelectionPage: `my account:insurance:${pageName}:review payment`,
      noEmailOnFilePage: `my account:insurance:${pageName}:no email on file`,
      emailOnFilePage: `my account:insurance:${pageName}:email on file`,
      confirmationPage: `my account:insurance:${pageName}:confirmation`,
      expiredConfirmationPage: `my account:insurance:${pageName}:confirmation-reload`,
      autoPayPage: `my account:insurance:${pageName}:${appFlow === AppFlow.AUTOPAY ? 'enrollment' : 'autopay'}`,
      alreadyPaid: `my account:insurance:${pageName}:already paid`,
      systemErrorPage: `my account:insurance:${pageName}:${
        appFlow === AppFlow.AUTOPAY ? UtagHelper.Errors.systemErrorAutoPayFlow : UtagHelper.Errors.systemError
      }`,
      paymentErrorPage: `my account:insurance:${pageName}:${
        appFlow === AppFlow.AUTOPAY ? UtagHelper.Errors.paymentErrorAutoPayFlow : UtagHelper.Errors.paymentError
      }`,
      notFoundPage: `my account:insurance:${pageName}:error-generic`,
    };
  };

  static loadUtagJs() {
    if (window.utagLoadAttempt) return;
    window.utagLoadAttempt = true;
    const utagJsScript = document.createElement('script');
    utagJsScript.src = '//tms.ace.aaa.com/ace/prod/utag.js';
    utagJsScript.type = 'text/javascript';
    utagJsScript.async = true;
    document.body.appendChild(utagJsScript);
  }

  static link(tags: UtagParam) {
    window.aceMediaTagValues = { ...tags };
    if (!window.utag) {
      this.loadUtagJs();
    } else {
      window.utag.link(window.aceMediaTagValues);
    }
  }

  static tag(tags: UtagParam) {
    window.aceMediaTagValues = { ...tags };
    this.dispatchTntSpaEvent(window.aceMediaTagValues);
    if (!window.utag) {
      this.loadUtagJs();
    } else {
      window.utag.view(window.aceMediaTagValues);
    }
  }

  static dispatchTntSpaEvent(tags: UtagParam) {
    document.dispatchEvent(
      new CustomEvent('tnt_spa', {
        detail: tags,
      })
    );
  }
}
